/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Aria_LabelInputs */

const en_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align text center`)
};

const fr_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner le texte au centre`)
};

const de_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text zentrieren`)
};

const it_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea il testo al centro`)
};

const ru_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выровнять текст по центру`)
};

const es_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear el texto al centro`)
};

const zh_cn2_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本居中对齐`)
};

const ja_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを中央揃え`)
};

const hi_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को केंद्र में संरेखित करें`)
};

const pt_pt2_align_center_aria_label = /** @type {(inputs: Align_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhar texto ao centro`)
};

/**
* | output |
* | --- |
* | "Align text center" |
*
* @param {Align_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_aria_label = /** @type {((inputs?: Align_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_center_aria_label(inputs)
	if (locale === "de") return de_align_center_aria_label(inputs)
	if (locale === "it") return it_align_center_aria_label(inputs)
	if (locale === "ru") return ru_align_center_aria_label(inputs)
	if (locale === "es") return es_align_center_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_align_center_aria_label(inputs)
	if (locale === "ja") return ja_align_center_aria_label(inputs)
	if (locale === "hi") return hi_align_center_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_align_center_aria_label(inputs)
	return en_align_center_aria_label(inputs)
});